import React, {useEffect, useRef, useState} from 'react';
import MediaLibraryManager from '../../Media/MediaLibraryManager';
import Modal from '../../../Modal';

export default function InlineMediaPicker({isOpen, pendingFile = null, onCancel, onInsert}) {
    const [file, setFile] = useState(pendingFile);
    const [altText, setAltText] = useState('');
    const [decorative, setDecorative] = useState(false);
    const altRef = useRef(null);

    useEffect(() => {
        setFile(pendingFile);
        setAltText(pendingFile?.metadata?.altText || pendingFile?.description || '');
        setDecorative(false);
    }, [pendingFile, isOpen]);

    useEffect(() => {
        if (file) altRef.current?.focus();
    }, [file]);

    if (!isOpen) return null;
    if (!file) {
        return <MediaLibraryManager
            variant="modal"
            isOpen
            selectable
            accept="image/*"
            title="Choose an inline image"
            onSelect={selected => setFile(selected)}
            onCancel={onCancel}
        />;
    }

    return <Modal isOpen title="Describe this image" onClose={onCancel}>
        <div className="content-inline-alt-fields">
            <p>Alt text helps people using screen readers understand the image.</p>
            <label htmlFor="content-inline-alt">Alt text</label>
            <input
                ref={altRef}
                id="content-inline-alt"
                value={altText}
                disabled={decorative}
                onChange={event => setAltText(event.target.value)}
            />
            <label className="checkbox" htmlFor="content-inline-decorative">
                <input
                    id="content-inline-decorative"
                    type="checkbox"
                    checked={decorative}
                    onChange={event => setDecorative(event.target.checked)}
                />
                <span>This image is decorative</span>
            </label>
            {!decorative && !altText.trim() && <p className="help">Enter alt text or mark it decorative.</p>}
            <div className="content-dialog-actions">
                <button type="button" className="button secondary" onClick={() => {
                    setFile(null);
                    if (pendingFile) onCancel();
                }}>Back</button>
                <button
                    type="button"
                    className="button"
                    disabled={!decorative && !altText.trim()}
                    onClick={() => onInsert(file, decorative ? '' : altText.trim())}
                >Insert image</button>
            </div>
        </div>
    </Modal>;
}
